<script setup>
import { WButton, WIcon, WTitle } from '@alice-health/wonderland-vue'
import { computed } from 'vue'

const props = defineProps({
  icon: {
    type: String,
    default: undefined
  },
  label: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: undefined
  },
  dataTheme: {
    type: String,
    default: 'on-light',
    validator: v => ['on-light', 'on-dark'].includes(v)
  },
  collapsed: {
    type: Boolean
  }
})

const emit = defineEmits(['onCollapse', 'onClose'])

const iconCollapse = computed(() => {
  return props.collapsed ? 'icArrowExpand1' : 'icArrowCollapse'
})

const handleCollapse = () => {
  emit('onCollapse')
}

const handleClose = () => {
  emit('onClose')
}
</script>

<template>
  <section
    class="float-element-header"
    :class="{ collapsed: collapsed }"
    :data-theme="dataTheme"
    :style="{
      '--background-color': color
    }"
  >
    <div class="float-element-header__section">
      <WIcon v-if="icon" :icon="icon" />
      <WTitle size="xsmall">{{ label }}</WTitle>
    </div>

    <div class="float-element-header__section">
      <WButton
        size="small"
        icon="icMenuHamburger"
        icon-button
        variant="tertiary"
      />
      <WButton
        size="small"
        :icon="iconCollapse"
        icon-button
        variant="tertiary"
        data-testid="button-collapse"
        @click="handleCollapse"
      />
      <WButton
        size="small"
        icon="icClose"
        icon-button
        variant="tertiary"
        data-testid="button-close"
        @click="handleClose"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.float-element-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--gl-spacing-01);
  cursor: move;
  background-color: var(--background-color);
  padding: var(--gl-spacing-03) var(--gl-spacing-06);
  border-radius: var(--gl-border-radius-md) var(--gl-border-radius-md) 0 0;

  &.collapsed {
    border-radius: var(--gl-border-radius-md);
  }

  &__section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--gl-spacing-01);
    color: var(--sys-color-content-primary);
  }
}
</style>
